<div class="form-input">
  <label *ngIf="label">{{ label! | translate }}</label>
  <div *ngIf="hasFilter" class="filters">
    <label>{{"common.filter.name" | translate}}</label>
    <div>
      @for(filter of filters; track filter) {
        <div>
          <input type="checkbox" class="checkbox" (click)="filterValue(filter)">
          <span>{{"enum.prestation-type-filter." + filter | translate}}</span>
        </div>
      }
    </div>
  </div>
  <div *ngIf="canMultiCheck" class="multicheck">
    <div>
      <input type="checkbox" class="checkbox" [(ngModel)]="selectAll" (change)="checkAll($event)">
      <span>{{ 'common.select-all' | translate }}</span>
    </div>

    <div>
      <input type="checkbox" class="checkbox" [(ngModel)]="unselectAll" (change)="uncheckAll($event)">
      <span>{{ 'common.unselect-all' | translate }}</span>
    </div>
  </div>

  <span *ngIf="hasFilter" class="divider"></span>
  <div class="prestationType-liste">
    <ul class="list" [style.height]="maxHeight">
      @if(options.length > 0) {
        <mat-accordion multi>
          @for(parent of options;track parent) {
            @if(parent.child) {
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <li class="item" [style.background-color]="'#FFFFFF'" [style.color]="parent?.color?.text">
                      <mat-checkbox class="example-margin"
                                    [checked]="parent.allSelected ?? false"
                                    [color]="'primary'"
                                    [indeterminate]="someComplete(parent)"
                                    (change)="setAll($event.checked, parent)">
                        {{parent.label}}
                      </mat-checkbox>
                    </li>
                  </mat-panel-title>
                </mat-expansion-panel-header>

                @for(child of parent.child;track child) {
                  <li class="item child" [style.background-color]="child?.color?.background"
                      [style.color]="child?.color?.text">
                    <mat-checkbox [(ngModel)]="child.selected"
                                  [color]="'primary'"
                                  (ngModelChange)="updateAllComplete(parent)">
                      {{child.label}}
                    </mat-checkbox>
                  </li>
                }
              </mat-expansion-panel>
            } @else {
              <li class="item" [style.background-color]="parent?.color?.background">
                <mat-checkbox [(ngModel)]="parent.selected"
                              [color]="'primary'"
                              (ngModelChange)="updateAllComplete(parent)">
                  <span [style.color]="parent?.color?.text">{{parent.label}}</span>
                </mat-checkbox>
              </li>
            }
          }
        </mat-accordion>
      } @else {
        <li class="empty">{{ 'common.noElementFound' | translate }}</li>
      }
    </ul>
  </div>
</div>
